/**
 * @file LeaveConfirmDialog.tsx
 * @description Окно «не сохранено» перед уходом из панели конструктора
 * (phase19.16 Р1-6а; uiux-builder-shell.md §6; ревью партии SB122 — общее
 * для панели блока и «Настроек страницы»): [Остаться] [Не сохранять]
 * [Сохранить]. Заголовок и пояснение — свои у каждой панели.
 *
 * ```tsx
 * <LeaveConfirmDialog leave={leave} title="Блок не сохранён" description="…" />
 * ```
 */

import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../../ui/alert-dialog";
import { Button } from "../../ui/button";
import type { BlockLeaveGuard } from "../../../hooks/site-builder/useBlockLeaveGuard";

interface Props {
  leave: BlockLeaveGuard;
  title: string;
  description: string;
}

export function LeaveConfirmDialog({ leave, title, description }: Props) {
  return (
    <AlertDialog open={leave.asking} onOpenChange={(open) => (!open ? leave.choose("stay") : null)}>
      <AlertDialogContent fullScreen className="max-w-md gap-3">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="ghost" onClick={() => leave.choose("stay")}>
            Остаться
          </Button>
          <Button variant="outline" onClick={() => leave.choose("discard")}>
            Не сохранять
          </Button>
          <Button onClick={() => leave.choose("save")}>Сохранить</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
